import Image from "next/image";
import styles from "./location-card.module.css";
import { MdDelete, MdInfoOutline, MdUpgrade } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { Location } from "../types";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useLocationsStore } from "../locations-store";

export default function LocationCard({
  location,
  onPreviewClick,
  idToken,
}: {
  location: Location;
  onPreviewClick: () => void;
  idToken: string | null;
}) {
  const uploadPhoto = useLocationsStore((state) => state.uploadPhoto);
  const deletePhotoUrl = useLocationsStore((state) => state.deletePhotoUrl);
  const upgradeToCity = useLocationsStore((state) => state.upgradeToCity);
  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        await uploadPhoto(acceptedFiles[0], location, idToken);
        // onUpload(acceptedFiles[0]);
      }
    },
    [uploadPhoto],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
  });
  return (
    <div className={styles.cardWrapper}>
      <div {...getRootProps()} className={styles.imageWrapper}>
        <input {...getInputProps()} />
        {location.has_photo ? (
          <Image
            className={styles.image}
            src={location.photo_url}
            width={1600}
            height={900}
            alt={`${location.name} location photo.`}
            priority={true}
          />
        ) : (
          <Image
            className={styles.image}
            src={"/broken_image.webp"}
            width={1600}
            height={900}
            alt="Empty placeholder image."
            priority={true}
          />
        )}
        {isDragActive && (
          <p className={styles.dropText}>Drop image to upload.</p>
        )}
        <div className={styles.buttonsWrapper}>
          <button
            onClick={async (e) => {
              e.stopPropagation();
              e.preventDefault();
              await deletePhotoUrl(location, idToken);
            }}
            className={styles.actionButton}
          >
            <MdDelete />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onPreviewClick();
            }}
            className={styles.actionButton}
          >
            <IoMdEye />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              upgradeToCity(location, !location.treat_as_city, idToken);
            }}
            className={styles.actionButton}
          >
            <MdUpgrade />
          </button>
        </div>
      </div>
      <div className={styles.locationInfo}>
        <p className={styles.locationName}>{location.name}</p>
        <p>Country slug: {location.country_slug}</p>
        <p>Photo url: {location.has_photo ? location.photo_url : "NO PHOTO"}</p>
        <p>
          Geo location: lat: {location.geo_location.lat}, long:{" "}
          {location.geo_location.lon}
        </p>
        <p className={styles.listingCount}>
          <span>Total listing count: {location.listing_count}</span>
          <span>
            <button>
              <MdInfoOutline />
            </button>
          </span>
        </p>
        <p>Type: {location.type}</p>
        <p>Treat as city: {location.treat_as_city ? "yes" : "no"}</p>
      </div>
    </div>
  );
}
